import { Tag } from 'antd';
import type { RiskLevel } from '../types/domain';
import { RISK_LABELS } from '../types/domain';

const COLOR: Record<RiskLevel, string> = {
  Low: 'green',
  Medium: 'gold',
  High: 'red',
};

export default function RiskBadge({ level }: { level: RiskLevel | null | undefined }) {
  if (!level) return <Tag>—</Tag>;
  return <Tag color={COLOR[level]}>{RISK_LABELS[level]}</Tag>;
}
